import React from 'react';
import classNames from 'classnames';
import {ReactComponent as Icon} from 'images/icon/comment.svg';

export default class CommentIcon extends React.PureComponent {
  render() {
    return (
      <Icon
        className={classNames('icon comment', this.props.className)}
        onClick={this.props.onClick}
      />
    );
  }
}
